/*
 * @Date: 2023-01-04 14:58:29
 * @LastEditors: huguochi@mail.com zheng@sense.sg
 * @LastEditTime: 2025-01-26 17:32:50
 * @FilePath: /nicee-h5/src/router-notice.js
 * @Description: 公告路由
 */


const routers = [
  // 违法公告
  {
    path: '/notice-illegal',
    name: 'Illegal',
    component: () => import('@/views/notice/illegal/index.vue'),
  },
  {
    path: '/voice-room-preview',
    name: 'VoiceRoomPreview',
    component: () => import('@/views/notice/voice-room-preview/index.vue'),
  },
  {
    path: '/notice-line-rc',
    name: 'notice-line-rc',
    component: () => import('@/views/notice/line-rc/index.vue'),
  },
  {
    path: '/notice-line',
    name: 'notice-line',
    component: () => import('@/views/notice/line/index.vue'),
  },
  {
    path: '/notice-line-player-custom',
    name: 'noticeLinePlayerCustom',
    component: () => import('@/views/notice/line-player/index.vue'),
  },
  {
    path: '/promise-win-qualification',
    name: 'PromiseWinQualification',
    component: () => import('@/pages/promise-win-qualification/index.vue'),
    meta: {
      waitUserInfo: true,
    },
  },
];
export default routers;
